import * as Yup from 'yup';

export const SalaryCertificateFormSchema = Yup.object({
  purpose: Yup.string().required('Please choose purpose'),
  requiredByDate: Yup.string().required('Please choose date'),
  language: Yup.string().required('Please choose language'),
  remarks: Yup.string(),
});
